import { Checkbox, FormGroup, Grid } from '@mui/material';
import { FC } from 'react';
import { FilterSection, FilterSectionTitle, FormControlLabel } from './filters.styles';

interface FilterOption {
  value: string;
  label: string;
  visible?: boolean;
}

interface FilterSectionProps {
  title: string;
  options: FilterOption[];
  selectedValues: string[];
  onChange: (value: string, checked: boolean) => void;
}

export const FilterSectionComponent: FC<FilterSectionProps> = ({ title, options, selectedValues, onChange }) => {
  const isChecked = (value: string): boolean => {
    return selectedValues.includes(value);
  };

  const visibleOptions = options.filter((option) => option.visible !== false);

  return (
    <FilterSection>
      <FilterSectionTitle>{title}</FilterSectionTitle>
      <FormGroup>
        <Grid container>
          {visibleOptions.map((option) => (
            <Grid item xs={6} key={option.value}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isChecked(option.value)}
                    onChange={(e) => onChange(option.value, e.target.checked)}
                    value={option.value}
                  />
                }
                label={option.label}
              />
            </Grid>
          ))}
        </Grid>
      </FormGroup>
    </FilterSection>
  );
};
